export default "__VITE_ASSET__1pUhcfaE__"